<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.members.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.browse.close' | translate" (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-2">
    <span class="chat-name">{{ data.channelName }}</span>
    @if (!loading && !loadFailed) {
      <span> · {{ 'chat.conversation.members' | translate:{ count: memberCount } }}</span>
    }
  </p>

  @if (loading) {
    <chat-sidebar-skeleton [rows]="5"></chat-sidebar-skeleton>
  } @else if (loadFailed) {
    <div class="text-center py-3">
      <p class="text-muted mb-2">{{ 'chat.members.error' | translate }}</p>
      <button type="button" class="btn btn-sm btn-soft-primary" (click)="load()">
        <i class="ri-refresh-line me-1"></i>{{ 'chat.members.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="mb-2">
      <input
        type="text"
        class="form-control"
        name="chatMembersFilter"
        [placeholder]="'chat.members.searchPlaceholder' | translate"
        [attr.aria-label]="'chat.members.searchPlaceholder' | translate"
        [(ngModel)]="filterTerm"
        (input)="applyFilter()"
      >
    </div>

    @if (filteredRows.length === 0) {
      <chat-empty-state
        icon="ri-user-search-line"
        titleKey="chat.members.empty"
        [hintKey]="null"
        [compact]="true"
      ></chat-empty-state>
    } @else {
      <div class="list-group list-group-flush chat-members-list overflow-auto">
        @for (member of filteredRows; track trackRow($index, member)) {
          <div class="list-group-item d-flex align-items-center gap-2 py-2">
            <!-- Same avatar tile as the invite dialog — photo/initials plus the
                 presence dot. -->
            <span class="chat-avatar-tile flex-shrink-0">
              @if (member.image) {
                <img [src]="member.image" [alt]="member.name">
              } @else {
                {{ member.initial }}
              }
              <span
                class="chat-avatar-tile__presence rounded-circle"
                [ngClass]="dotFor(member)"
                aria-hidden="true"
              ></span>
            </span>
            <span class="flex-grow-1 chat-name text-truncate">
              {{ member.name }}
              @if (member.isSelf) {
                <small class="text-muted">({{ 'chat.members.you' | translate }})</small>
              }
            </span>
            @if (member.isAdmin) {
              <span class="badge bg-soft-primary text-primary flex-shrink-0">
                {{ 'chat.members.admin' | translate }}
              </span>
            }
          </div>
        }
      </div>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.browse.close' | translate }}</button>
</div>
